import PasswordValidator from 'password-validator'

const schema = new PasswordValidator()

schema
  .is()
  .min(8)
  .has()
  .digits()
  .has()
  .uppercase()
  .has()
  .lowercase()
  .has()
  .symbols()
  .has()
  .not()
  .spaces()
  .is()
  .not()
  .oneOf(['Passw0rd', 'Password123'])

const errorMessages = {
  min: 'A senha deve conter pelo menos 8 caracteres',
  digits: 'A senha deve conter pelo menos 1 número',
  uppercase: 'A senha deve conter pelo menos 1 letra maiúscula',
  lowercase: 'A senha deve conter pelo menos 1 letra minúscula',
  symbols: 'A senha deve conter pelo menos 1 caractere especial (~ ! # $ * - _ + = ? [ ] ( ))',
  spaces: 'A senha não pode conter espaços',
  oneOf: 'Esta senha é muito comum e não pode ser utilizada'
}

export const validatePassword = (password) => {
  return schema.validate(password)
}

const getPasswordErrors = (password) => {
  if (!password) {
    return ['A senha é obrigatória']
  }

  const failedRules = schema.validate(password, { list: true })

  if (failedRules.length === 0) {
    return []
  }

  return failedRules.map(
    (rule) => errorMessages[rule] || 'Ocorreu um erro desconhecido com a senha atual, tente novamente com outra senha.'
  )
}

export const getPasswordErrorMessage = (password) => {
  const errors = getPasswordErrors(password)
  return errors.length > 0 ? errors.join('. ') : ''
}
